import React from "react";
import { api } from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Calendar as CalendarIcon, Sparkles, Moon, Star, PartyPopper } from "lucide-react";

const CAT_META = {
    holiday: { color: "bg-blue-100 text-blue-800", icon: PartyPopper, label: "Holiday" },
    school: { color: "bg-primary/10 text-primary", icon: CalendarIcon, label: "School" },
    ramadan: { color: "bg-purple-100 text-purple-800", icon: Moon, label: "Ramadan" },
    eid: { color: "bg-accent/20 text-accent", icon: Sparkles, label: "Eid" },
    community: { color: "bg-emerald-100 text-emerald-800", icon: Star, label: "Community" },
};

export default function CalendarPage() {
    const [events, setEvents] = React.useState([]);
    React.useEffect(() => { api.get("/events").then(r => setEvents(r.data)).catch(() => { }); }, []);

    return (
        <main className="py-16">
            <div className="max-w-6xl mx-auto px-6 lg:px-10">
                <div className="overline text-brand-stone mb-3">Islamic calendar & events</div>
                <h1 className="font-serif text-5xl text-brand-ink leading-tight">
                    A year in <span className="italic text-primary">rhythm</span>.
                </h1>
                <p className="mt-5 text-brand-stone max-w-2xl">
                    School holidays, Ramadan, Eid celebrations, and community gatherings — all in one place.
                </p>
                <div className="mt-14 space-y-3">
                    {events.map((e, i) => {
                        const meta = CAT_META[e.category] || CAT_META.school;
                        const Icon = meta.icon;
                        const d = new Date(e.date);
                        return (
                            <Card key={e.id} className="card-lift border-border/60" style={{ animationDelay: `${i * 60}ms` }}>
                                <CardContent className="p-6 flex flex-wrap md:flex-nowrap items-center gap-6">
                                    <div className="flex-shrink-0 w-20 text-center">
                                        <div className="overline text-brand-stone">{d.toLocaleString("en-US", { month: "short" })}</div>
                                        <div className="font-serif text-3xl text-brand-ink">{d.getDate()}</div>
                                        <div className="text-xs text-brand-stone">{d.getFullYear()}</div>
                                    </div>
                                    <div className="w-px self-stretch bg-border hidden md:block" />
                                    <div className="flex-1 min-w-0">
                                        <div className="flex items-center gap-2 mb-1">
                                            <Icon className="w-3.5 h-3.5" />
                                            <Badge className={`${meta.color} border-0 rounded-full`}>{meta.label}</Badge>
                                        </div>
                                        <div className="font-dash text-lg font-semibold text-brand-ink">{e.title}</div>
                                        {e.description && <p className="text-sm text-brand-stone mt-1">{e.description}</p>}
                                    </div>
                                </CardContent>
                            </Card>
                        );
                    })}
                    {events.length === 0 && (
                        <div className="text-center py-16 text-brand-stone">No events yet. Check back soon.</div>
                    )}
                </div>
            </div>
        </main>
    );
}
